import { createReducer, on } from '@ngrx/store';
import { assessmentActions } from '../actions/assessment.actions';
import { Assessment } from '../models';

export interface AssessmentState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    assessment: Assessment | null;
}

export const initialState: AssessmentState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    assessment: null,
};

export const assessmentReducer = createReducer(
    initialState,
    on(assessmentActions.getAssessment, (state): AssessmentState => ({
        ...state,
        loading: true,
        loaded: null,
        error: null,
    })),
    on(assessmentActions.getAssessmentSuccess, (state, { payload }): AssessmentState => ({
        ...state,
        loading: false,
        loaded: true,
        error: null,
        assessment: payload,
    })),
    on(assessmentActions.getAssessmentError, (state, payload): AssessmentState => ({
        ...state,
        loading: false,
        loaded: false,
        error: payload.code,
    })),
    on(assessmentActions.saveAssessment, (state): AssessmentState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(assessmentActions.saveAssessmentSuccess, (state, { payload }): AssessmentState => ({
        ...state,
        saving: false,
        saved: true,
        assessment: payload,
    })),
    on(assessmentActions.saveAssessmentError, (state): AssessmentState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(assessmentActions.patchAssessment, (state): AssessmentState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(assessmentActions.patchAssessmentSuccess, (state, { payload }): AssessmentState => ({
        ...state,
        saving: false,
        saved: true,
        assessment: payload,
    })),
    on(assessmentActions.patchAssessmentError, (state): AssessmentState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(assessmentActions.deleteAssessment, (state): AssessmentState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(assessmentActions.deleteAssessmentSuccess, (state): AssessmentState => ({
        ...state,
        saving: false,
        saved: true,
        assessment: null,
    })),
    on(assessmentActions.deleteAssessmentError, (state): AssessmentState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(assessmentActions.clear, (): AssessmentState => ({ ...initialState })),
);
